import { styled } from "@mui/material/styles";
import PhoneMobileComponent from "./phone-mobile.svg";
import PhoneComponent from "./phone.svg";

export const Container = styled("div", {
  label: "art",
})`
  position: relative;
  align-items: center;
  height: 100%;

  ${({ theme }) => theme.breakpoints.up("md")} {
    height: 80%;
  }
`;

export const PhoneMobileView = styled(PhoneMobileComponent, {
  label: "phone-mobile",
})`
  height: 100%;
  width: 100%;
`;
export const PhoneView = styled(PhoneComponent, {
  label: "phone",
})`
  height: 100%;
`;
